import RouterConstants from '../constants/RouterConstants';

export default function transitionMiddleware({ dispatch, getState }) { // eslint-disable-line no-unused-vars
  return next => (action) => {
    const { transition, middlewareData, ...rest } = action; // eslint-disable-line no-unused-vars
    if (!transition) {
      return next(action);
    }

    const nextAction = next(action);
    const { history, to, query, external } = transition(getState());

    if (external && __CLIENT__) {
      window.location = to;
    }

    if (history) {
      const updatedQuery = Object.assign({}, query);
      history.push(history.createHref({ pathname: to, query: updatedQuery }));
      return next({ ...rest, transition, type: RouterConstants.ROUTER_TRANSITION });
    }
    return nextAction;
  };
}



// WEBPACK FOOTER //
// ./app/reduxMiddlewares/transitionMiddleware.js